import { render } from "./Proposals.vue?vue&type=template&id=60d5bc16"
import script from "./Proposals.vue?vue&type=script&lang=js"
export * from "./Proposals.vue?vue&type=script&lang=js"
script.render = render

export default script